import { render, staticRenderFns } from "./BrandComments.vue?vue&type=template&id=090d3bb0&scoped=true&"
import script from "./BrandComments.vue?vue&type=script&lang=js&"
export * from "./BrandComments.vue?vue&type=script&lang=js&"
import style0 from "./BrandComments.vue?vue&type=style&index=0&id=090d3bb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d3bb0",
  null
  
)

export default component.exports